module.exports = __webpack_public_path__ + "img/sport_cover.ed166db8.webp";